import React from 'react'

import Header from './Header'
import Footer from './Footer'

class PrivacyPolicy extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {
        return (
            <main className="job">
                <Header />
                <section className="subheader">
                    <div className="filter-openHome">
                        <h1>Aviso legal</h1>
                    </div>
                </section>
                <section className="content">
                    <p>
                        <span>
                            En cumplimiento con el artículo 10 de la Ley 34/2002, del 11 de julio, de servicios de la Sociedad de la Información y Comercio Electrónico (LSSICE) se
                            exponen a continuación los datos identificativos de la empresa.
                        </span>
                    </p>
                    <p>
                        <span>
                            <b>Denominación fiscal: </b>
                        </span>
                        <span>Servicios Empresariales y Tecnológicos Integrados, S.L. en adelante, OPENHOME,</span>
                        <br />
                        <span>
                            <b>Número de identificación fiscal: </b>
                        </span>
                        <span>B04694345</span>
                        <br />
                        <span>
                            <b>Datos Registrales:</b>
                        </span>
                        <span>
                            inscrita en el Registro Mercantil de Almería al tomo 1369 , libro 0, folio 106, hoja AL-35957, correspondiéndonos el ejercicio exclusivo de los derechos
                            de explotación de los mismos.
                        </span>
                        <br />
                        <span>
                            <b>Correo electrónico:</b> info@checkcontrol.com
                        </span>
                    </p>
                    <h2>
                        <strong>
                            <span> </span>
                        </strong>
                    </h2>
                    <h2>
                        <strong>
                            <span>Términos y Condiciones</span>
                        </strong>
                    </h2>
                    <p>
                        <span>
                            Los presentes Términos y Condiciones regulan el uso permitido de esta página web que OPENHOME pone a disposición de los usuarios de Internet, así como
                            cualquier comunicación por email entre nosotros y usted.
                        </span>
                    </p>
                    <h3>
                        <span>1. General. </span>
                    </h3>
                    <p>
                        <strong>
                            <span>1.1. </span>
                        </strong>
                        <span>
                            Los sitios <strong>openHome</strong>
                            .com y <strong>openHome</strong>
                            .org, incluyendo cualquier subdominio de los mismos y las aplicaciones móviles (denominados colectivamente el &ldquo;Sitio Web&rdquo;), son propiedad y
                            están operados por OPENHOME
                        </span>
                    </p>
                    <p>
                        <strong>
                            <span>1.2. </span>
                        </strong>
                        <span> Las referencias a </span>
                        <span>
                            &ldquo;OPENHOME&rdquo;, &ldquo;nosotros&rdquo;, &ldquo;nos&rdquo;, &ldquo;nuestro&rdquo;, &ldquo;nuestros&rdquo;, &ldquo;nuestra&rdquo; y
                            &ldquo;nuestras&rdquo; son referencias a <span>Servicios Empresariales y Tecnológicos Integrados, S.L</span>, sus órganos directivos y accionistas
                            <span>.</span>
                        </span>
                    </p>
                    <p>
                        <strong>
                            <span>1.3. </span>
                        </strong>
                        <span>
                            Las referencias a &ldquo;usted&rdquo;, &ldquo;su&rdquo;, &ldquo;sus&rdquo;, &ldquo;tu&rdquo;, &ldquo;tus&rdquo;, &ldquo;usuario&rdquo;,
                            &ldquo;usuarios&rdquo;, &ldquo;cliente&rdquo; y &ldquo;clientes&rdquo; se harán en relación a cualquier persona que visite y/o utilice el Sitio Web y/o
                            los servicios del Sitio Web.
                        </span>
                    </p>
                    <p>
                        <strong>
                            <span>1.4. </span>
                        </strong>
                        <span>Al usar y/o visitar cualquier sección del Sitio Web usted acepta que quedará vinculado por estos Términos y Condiciones. </span>
                    </p>
                    <p>
                        <strong>
                            <span>1.5. </span>
                        </strong>
                        <span>
                            Los Términos y Condiciones constituyen su acuerdo con OPENHOME. Lea atentamente los Términos y Condiciones y si decide no aceptarlos, no utilice el
                            Sitio Web. El uso del Sitio Web constituirá la aceptación de los Términos y Condiciones.
                        </span>
                    </p>
                    <p>
                        <strong>
                            <span>1.6. </span>
                        </strong>
                        <span>
                            OPENHOME se reserva el derecho a modificar los Términos y Condiciones en cualquier momento y sin notificación previa. Por lo tanto, usted tiene la
                            responsabilidad de repasar frecuentemente los Términos y Condiciones. El uso del Sitio Web después de la introducción de tales modificaciones
                            constituirá la aceptación por su parte de dichos cambios.
                        </span>
                    </p>
                    <p>
                        <strong>
                            <span>1.7. </span>
                        </strong>
                        <span>
                            Si alguna disposición o cláusula de los Términos y Condiciones se determina que es inaplicable por un tribunal de jurisdicción competente, dicha
                            disposición o cláusula se eliminará y el resto de disposiciones o cláusulas de los Términos y Condiciones se mantendrán en plena vigencia.
                        </span>
                    </p>
                    <p>
                        <strong>
                            <span>1.8. </span>
                        </strong>
                        <span>
                            Los encabezamientos de las distintas disposiciones o cláusulas son sólo informativos, y no afectarán, calificarán o ampliarán la interpretación de los
                            Términos y Condiciones.
                        </span>
                    </p>
                    <p>
                        <strong>
                            <span>1.9. </span>
                        </strong>
                        <span>
                            El uso de los términos &ldquo;incluido&rdquo;, &ldquo;incluyendo&rdquo;, &ldquo;tales como&rdquo; y términos similares no limita que otros elementos se
                            incluyan también.
                        </span>
                    </p>
                    <h3>
                        <span>2. Idiomas. </span>
                    </h3>
                    <p>
                        <strong>
                            <span>2.1. </span>
                        </strong>
                        <span>
                            Los Términos y Condiciones, así como el resto de textos del Sitio Web, han sido redactados en espa&ntilde;ol, y puede que se hayan traducido a los otros
                            idiomas disponibles en el Sitio Web. En el caso de que surgiera alguna discrepancia entre el espa&ntilde;ol y los textos traducidos, prevalecerá el
                            texto en espa&ntilde;ol, que se usará para resolver cualquier duda que surja sobre su interpretación o aplicación.
                        </span>
                    </p>
                    <h3>
                        <span>3. Acceso y uso del Sitio Web. </span>
                    </h3>
                    <p>
                        <strong>
                            <span>3.1. </span>
                        </strong>
                        <span>
                            OPENHOME le otorga un privilegio personal, limitado, no exclusivo e intransferible para que acceda y utilice el Sitio Web. OPENHOME podrá rescindir este
                            privilegio de inmediato en caso de incumplimiento de cualquiera de los Términos y Condiciones, o en cualquier momento a discreción de OPENHOME. En este
                            caso, OPENHOME puede adoptar medidas para impedir el uso ulterior por su parte del Sitio Web, incluyendo el bloqueo de su dirección IP.
                        </span>
                    </p>
                    <p>
                        <strong>
                            <span>3.2. </span>
                        </strong>
                        <span>
                            El acceso al Sitio Web está permitido de manera temporal y OPENHOME podrá suspender o poner fin al funcionamiento o acceso a la totalidad del Sitio Web,
                            o ciertas partes del Sitio Web, por cualquier motivo y en cualquier momento, con o sin previo aviso, y sin tener en cuenta las condiciones anteriores.
                            OPENHOME no será responsable si, por cualquier razón, el Sitio Web no se encuentra disponible en cualquier momento o en cualquier período.
                        </span>
                    </p>
                    <p>
                        <strong>
                            <span>3.3</span>
                        </strong>
                        <span>
                            {' '}
                            OPENHOME se reserva el derecho a retirar, suspender o modificar cualquier aspecto, contenido o característica del Sitio Web por cualquier motivo y en
                            cualquier momento, con o sin previo aviso, y sin tener en cuenta las condiciones anteriores.
                        </span>
                    </p>
                    <p>
                        <strong>
                            <span>3.4. </span>
                        </strong>
                        <span>
                            Usted no deberá hacer uso del Sitio Web para fines que (según la opinión de OPENHOME) puedan ser considerados ilegales, difamatorios, ofensivos u
                            obscenos, o bien, que OPENHOME considere que son discriminatorios, fraudulentos, deshonestos o inapropiados.
                        </span>
                    </p>
                    <p>
                        <strong>
                            <span>3.5. </span>
                        </strong>
                        <span>
                            Está prohibido publicar, reproducir o difundir de cualquier forma la totalidad o parte de los contenidos expuestos en el Sitio Web, ya sea en forma
                            editorial, gráfica o pictórica, sin el consentimiento expreso de OPENHOME{' '}
                        </span>
                    </p>
                    <p>
                        <strong>
                            <span>3.6. </span>
                        </strong>
                        <span>
                            Usted no puede utilizar page-scrape (extracción de datos), robots, spiders (ara&ntilde;as) u otros dispositivos automáticos o manuales, para acceder,
                            adquirir, copiar o hacer un seguimiento del Sitio Web o su contenido, con el fin de obtener o intentar obtener materiales, documentos o información.
                        </span>
                    </p>
                    <p>
                        <strong>
                            <span>3.7. </span>
                        </strong>
                        <span>
                            Excepto si está autorizado por OPENHOME por escrito, usted no puede sondear, examinar ni probar la vulnerabilidad de ningún sistema o red de OPENHOME
                        </span>
                    </p>
                    <h3>
                        <span>4. Exclusión de garantías y Limitación de responsabilidad. </span>
                    </h3>
                    <p>
                        <strong>
                            <span>4.1. </span>
                        </strong>
                        <span>
                            Aunque OPENHOME ha tomado todas las precauciones razonables para asegurarse de que la información contenida en el Sitio Web sea veraz en el momento de
                            su publicación, OPENHOME no declara ni garantiza de forma tácita ni explícita (y en esto se incluye también su responsabilidad hacia terceras partes) su
                            exactitud, fiabilidad ni integridad. Por lo tanto, OPENHOME no asume responsabilidad alguna por el uso o la interpretación de la información contenida
                            en el Sitio Web. Usted usa el Sitio Web &ldquo;tal cual&rdquo; se presenta, &ldquo;según su disponibilidad&rdquo;, y por su cuenta y riesgo, sin
                            garantías de ninguna índole, explícitas o implícitas.
                        </span>
                    </p>
                    <p>
                        <strong>
                            <span>4.2. </span>
                        </strong>
                        <span>
                            En particular y sin limitación, OPENHOME no declara ni ofrece garantías de que (i) el Sitio Web y sus servicios satisfagan sus requisitos; (ii) los
                            servicios y funciones del Sitio Web queden interrumpidos, sean oportunos ni seguros, o estén exentos de errores; (iii) los resultados que se obtengan
                            con el uso del Sitio Web y los servicios del Sitio Web sean fiables o exactos; (iv) se corrijan los errores que presenten sus contenidos; ni de que (v)
                            el Sitio Web, los servidores que lo hagan disponible o cualquier e-mail enviado desde OPENHOME estén exentos de virus u otros elementos da&ntilde;inos.
                        </span>
                    </p>
                    <p>
                        <strong>
                            <span>4.3. </span>
                        </strong>
                        <span>
                            OPENHOME no será responsable por cualquiera de las siguientes pérdidas o da&ntilde;os (aunque tales pérdidas se previeran, fueran previsibles, o fueran
                            conocidas o no): (i) pérdida de datos; (ii) pérdida de ingresos o beneficios previstos; (iii) pérdida de negocio; (iv) pérdida de oportunidades; (v)
                            pérdida de buena voluntad o un perjuicio a la reputación; (vi) pérdidas sufridas por terceros; y/o (vii) ningún da&ntilde;o indirecto, consecuencial,
                            especial o da&ntilde;os punitivos derivados de la utilización del Sitio Web independientemente de la forma de acción.
                        </span>
                    </p>
                    <p>
                        <strong>
                            <span>4.4. </span>
                        </strong>
                        <span>
                            Todos los materiales descargados u obtenidos de cualquier forma mediante el uso del Sitio Web correrán por su cuenta y riesgo. Usted será el único
                            responsable de los da&ntilde;os y perjuicios que sufra su sistema informático o de la pérdida de datos que resulte de la descarga de dicho material.
                        </span>
                    </p>
                    <h3>
                        <span>5. Sitios Enlazados. </span>
                    </h3>
                    <p>
                        <strong>
                            <span>5.1. </span>
                        </strong>
                        <span>
                            El Sitio Web puede incluir contenidos de terceros y enlaces a otros sitios web (denominados colectivamente &ldquo;Sitios Enlazados&rdquo;). Los Sitios
                            Enlazados se ofrecen exclusivamente para la conveniencia de nuestros usuarios. Los Sitios Enlazados no están bajo el control de OPENHOME y por lo tanto,
                            OPENHOME no se responsabiliza por el contenido, la privacidad u otras prácticas de los Sitios Enlazados, incluida la información y los materiales que
                            contengan. La inclusión de los Sitios Enlazados no implica ningún tipo de aval por parte de OPENHOME a favor de ningún tercero. Usted reconoce y acepta
                            que OPENHOME no es responsable, ni directa ni indirectamente, de ningún da&ntilde;o o perjuicio causado, o supuestamente causado, por el uso de los
                            Sitios Enlazados. Por lo tanto, usted debe llevar a cabo las averiguaciones que considere pertinentes o apropiadas antes de realizar cualquier operación
                            con estos terceros.
                        </span>
                    </p>
                    <h3>
                        <span>6. Política de Privacidad. </span>
                    </h3>
                    <p>
                        <strong>
                            <span>6.1. </span>
                        </strong>
                        <span>
                            Cualquier información personal que nos comunique será tratada de acuerdo con nuestra Política de Privacidad, cuyos términos se entienden incorporados a
                            estos Términos y Condiciones por la mera referencia.
                        </span>
                    </p>
                    <h3>
                        <span>7. Propiedad intelectual. </span>
                    </h3>
                    <p>
                        <strong>
                            <span>7.1. </span>
                        </strong>
                        <span>
                            OPENHOME se reserva todos los derechos, incluyendo pero no limitado a cualquier derecho de autor, marca, patente, secreto comercial, y cualquier otro
                            derecho de propiedad. Al hacer que los servicios estén disponibles, OPENHOME no le proporciona a usted ningún derecho implícito o expreso.
                        </span>
                    </p>
                    <p>
                        <strong>
                            <span>7.2. </span>
                        </strong>
                        <span>
                            Ningún acto de descarga, copia o reproducción de cualquier otro tipo desde el Sitio Web le transfiere a usted derechos de titularidad sobre el software
                            o material alguno del Sitio Web.
                        </span>
                    </p>
                    <p>
                        <strong>
                            <span>7.3. </span>
                        </strong>
                        <span>
                            Excepto por lo que respecta a lo especificado anteriormente, se le concede a usted permiso para ver, almacenar, imprimir, reproducir, distribuir
                            cualquier página o descargarse cualquier material del Sitio Web para su uso personal y no comercial únicamente, siempre que no modifique ninguna página
                            ni material. Toda reproducción no autorizada y con finalidades comerciales del Sitio Web o de cualquier parte que este contenga constituye una
                            contravención de los derechos de OPENHOME.
                        </span>
                    </p>
                    <h3>
                        <span>8. Propiedad intelectual de terceros. </span>
                    </h3>
                    <p>
                        <strong>
                            <span>8.1. </span>
                        </strong>
                        <span>
                            Usted acuerda que las disposiciones que se establecen en los puntos 7.1. y 7.2. anteriores respecto de la titularidad de los derechos de OPENHOME
                            también son aplicables a los derechos de terceros respecto de los servicios y contenidos de las páginas, dominios o información presentada de los Sitios
                            Enlazados.
                        </span>
                    </p>
                    <h3>
                        <span>9. Legislación y jurisdicción aplicables. </span>
                    </h3>
                    <p>
                        <strong>
                            <span>9.1. </span>
                        </strong>
                        <span>
                            Los Términos y Condiciones y la relación que mantengas con OPENHOME se regirán por las leyes de Espa&ntilde;a. Usted y OPENHOME os comprometéis a
                            someteros únicamente a la jurisdicción de los tribunales de Almería, teniendo en cuenta, no obstante, que OPENHOME puede solicitar medidas o soluciones
                            en cualquier otra jurisdicción a fin de ejecutar los derechos que le corresponden de acuerdo con los Términos y Condiciones.
                        </span>
                    </p>
                    <p>
                        <strong>
                            <span>9.2. </span>
                        </strong>
                        <span>
                            El hecho de que OPENHOME no ejercite cualquier derecho o cláusula de los Términos y Condiciones no se considerará como una renuncia a tal derecho o
                            cláusula.
                        </span>
                    </p>
                    <p> </p>
                </section>
                <Footer />
            </main>
        )
    }
}

export default PrivacyPolicy



// WEBPACK FOOTER //
// ./src/components/LegalNotice.js